import React, { useEffect, useState, Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import 'antd/dist/antd.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import AdminLayout from "layouts/Admin.jsx";
import Login from "components/Login/Login.js";
import ResetPassword from "components/ResetPassword/ResetPassword.js";
import { RedisDataContext } from "context/RedisDataContext";
import sideBarRoutes from "./utilities/SidebarRoute";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { LanguageContext } from "context/LanguageContext";
import { useTranslation } from 'react-i18next';
import "./i18";
import QrCode from "views/qr-code";
import CallToAction from "views/calltoaction";
import cookieManagement from 'utilities/Cookie';
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
const cookies = new Cookies();

const App = props => {
  const { t, i18n } = useTranslation();
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const [finalSideBar, setFinalSideBar] = useState([]);
  const [language, setLanguage] = useState([]);
  const featureBluePrint = useState({});
  const globalLoaderValue = useState('0');
  const [wizardData, setWizardData] = useState({
    productsView: [],     //dropdownApiEndPoint  response
    productsDetail: []    //getApiEndPoint response
  })
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',

    }
  ]


  const loadingMarkup = (
    <div className="py-4 text-center">
      <h3>Loading..</h3>
    </div>
  )

  useEffect(() => {
    cookies.get('clientToken') == undefined ? cookieManagement.saveClientTokenToCookie() : cookies.get('clientToken');
  }, []);

  useEffect(() => {
    if (cookies.get('accessToken')) {
     if(localStorage.getItem('newSidebar') === 'undefined'){
      return null
    }else{
    let chec = JSON.parse(localStorage.getItem('newSidebar'));
      setFinalSideBar(sideBarRoutes.setSideBarRoutes(chec));
    }
    }
  }, [cookies.get('accessToken')]);

  useEffect(() => {
    if (i18n.language === 'chi') {
      let  chineseyml= JSON.parse(localStorage.getItem('chineseSidebar'));
    }
  }, [i18n.language]);


  return (
    <BrowserRouter>
    <Suspense fallback={loadingMarkup}>
      <Route path="/health-check" render={() => <div><p>Health Check - Success</p></div>} />
      <GlobalLoadIndicator.Provider value={globalLoaderValue}>
        <FeatureBlueprintContext.Provider value={featureBluePrint}>
          <RedisDataContext.Provider value={finalSideBar}>
            <LanguageContext.Provider value={language}>
            <WizardDataContext.Provider value={[wizardData, setWizardData]}>
            <Switch>
              <Route path="/admin" render={props => <AdminLayout {...props} />} />
              <Route path="/login" exact component={Login} />
              <Route path="/qr-code" exact component={QrCode} />
              <Route path="/product-detail" exact component={CallToAction} />
              <Route path="/" exact component={Login} />
              <Route path="/resetpassword" component={ResetPassword} />
              {/* <Route path="/admin/dashboard" component={PageType7} /> */}
            </Switch>
            </WizardDataContext.Provider>
            </LanguageContext.Provider>
          </RedisDataContext.Provider>
        </FeatureBlueprintContext.Provider>
      </GlobalLoadIndicator.Provider>
      </Suspense>
    </BrowserRouter>
  );
}

ReactDOM.render(React.createElement(App, null), document.getElementById("root"));